import { COLUMN_DURATION, COLUMN_DURATION_WARNING, COLUMN_NAME } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const ExpiryReasonColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "erName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Duration",
        accessor: "duration",
        isNumeric: false,
        id: 1,
        sortByName: "erDuration",
        sortDirection: "asc",
        active: true,
        translationKey: "duration",
        columnId: COLUMN_DURATION,
    },
    {
        heading: "Duration Warning",
        accessor: "durationWarning",
        isNumeric: false,
        id: 2,
        sortByName: "erDurationWarn",
        sortDirection: "asc",
        active: true,
        translationKey: "durationWarning",
        columnId: COLUMN_DURATION_WARNING
    },
];

export default ExpiryReasonColumns;
